export default "__VITE_ASSET__BCpvqaLV__"